import { render } from "./LanguageSwitcher.vue?vue&type=template&id=5cf4b426"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrii/Documents/Projects/optometry-academy-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__